import { Box, Container, Heading, Body } from '@hover/blueprint';
import React from 'react';
import SlideDesktop from './SlideDesktop';
import SlideMobile from './SlideMobile';

const CaseStudies: React.FC = () => (
  <Box
    width="100%"
    bg={{ base: 'neutral.0', desktop: 'brandNavy.100' }}
    pt={{ base: 700, desktop: 1000 }}
    pb={{ base: 0, desktop: 1000 }}
    borderRadius={{ base: '8px', tablet: 0 }}
    px={500}
  >
    <Container
      borderRadius={{ base: '8px', desktop: 0 }}
      pt={{ base: 700, desktop: 0 }}
      pb={{ base: 700, tablet: 1000, desktop: 0 }}
      shadow={{ base: 'distance300', desktop: 'none' }}
      maxW="1200px"
      bg="brandNavy.100"
    >
      <Box
        mx={{ base: 'auto', desktop: 0 }}
        mb={{ base: 600, desktop: '80px' }}
        flexDir="column"
        maxW={{ base: 'xl', desktop: '100%' }}
      >
        <Box
          bg="brandNavy.500"
          w="120px"
          height="30px"
          alignItems="center"
          justifyContent="center"
          mb={600}
          borderRadius="8px"
        >
          <Body
            size={200}
            fontWeight={{ base: 500, desktop: 700 }}
            borderRadius={300}
            color="neutral.0"
            as="h2"
          >
            CASE STUDIES
          </Body>
        </Box>
        <Heading
          size={{ base: 500, desktop: 700 }}
          style={{ marginBottom: 0 }}
          as="h3"
        >
          Rapid Roofing more than doubled their close rate with HOVER.
        </Heading>
      </Box>
      <SlideDesktop />
      <SlideMobile />
    </Container>
  </Box>
);

export default CaseStudies;
